import { objectsRHandler } from '@/utils/objectsRHandler';

import EventAttribute from '../list/event-attribute';

const API_PATH = 'admin/event-global-attributes';

export const AdminEventGlobalAttributesManager = {
  objects: objectsRHandler(API_PATH, EventAttribute),
};
